const loaded: Record<string, boolean> = {}

export async function loadScript(url: string) {
    if(loaded[url]) return true

    new Promise((resolve, reject) => {
        const script = document.createElement('script')

        script.onload = () => {
            resolve(true)
        }

        script.onerror = (e) => {
            console.log('Error loading script', e)
            reject(e)
        }

        script.async = true
        script.src = url

        document.head.appendChild(script)
    })
}
